<template>
	<a-tabs default-active-key="1" @change="callback">
		<a-tab-pane key="1" tab="待采购">
			<div class="content_main">
				<!-- <div class="content_main_top">
					<a-button type="primary" @click="exp"> 数据导出 </a-button>
				</div> -->
				<div class="content_main_top">
					<a-input v-model="purchaseCode" allowClear class="a_input_self margin_self" placeholder="采购申请单号"
					 @keyup.enter.native="query" />
					<a-select show-search allowClear placeholder="采购申请公司" class="margin_self" @change="handlecompany" v-model="companyId"
					 @keyup.enter.native="query" style="width: 160px">
						<a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
							{{ item.title }}
						</a-select-option>
					</a-select>
					<a-tree-select allowClear :treeData="deptTree2" v-model="deptId" :disabled="!companyId" placeholder="采购申请部门" @keyup.enter.native="query"
					 @change="handledept" style="width: 160px" class="margin_self" treeDefaultExpandAll>
					</a-tree-select>
					<!-- <a-select show-search allowClear v-model="deptId" :disabled="!companyId" placeholder="采购申请部门" class="margin_self"
					 @keyup.enter.native="query" style="width: 160px" @change="handledept">
						<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
							{{ item.dept_name }}
						</a-select-option>
					</a-select> -->
					<a-input v-model="createBy" allowClear class="a_input_self margin_self" placeholder="采购申请人" @keyup.enter.native="query" />
					<a-select show-search allowClear placeholder="资产类别" class="margin_self" v-model="itemType" style="width: 120px"
					 @keyup.enter.native="query">
						<a-select-option :value="index" v-for="(item, index) in goodsTypeObj" :key="index">
							{{ item }}
						</a-select-option>
					</a-select>
					<a-input v-model="name" allowClear class="a_input_self margin_self" placeholder="物品名称"
					 @keyup.enter.native="query" />
					<a-button type="primary" v-if='purchaseInfoPurchase' @click="query"> 查询 </a-button>
					<a-button type="primary" ghost @click="result"> 重置 </a-button>
					<a-button type="primary" @click="exportData"> 导出 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll">
					<a-table :columns="columns" :data-source="data" bordered :pagination="pagination" @change="handleTableChange"
					 :scroll="{x: 2100, y: scroll_y }">
						<span slot="index" slot-scope="text, record,index">
							{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
						</span>
						<span slot="itemType" slot-scope="text">
							{{ text ?goodsTypeObj[text]:''}}
						</span>
						<span slot="action" slot-scope="text, record">
							<a v-if="purchaseUpdatePurchase" @click="Goshopping(record)">去采购</a>
							<a-divider v-if="purchaseUpdatePurchase" type="vertical" />
							<a @click="voids(record)">作废</a>
							<a-divider type="vertical" />
							<a @click="details(record)">详情</a>
						</span>
					</a-table>
				</div>
			</div>
		</a-tab-pane>
		<a-tab-pane key="2" tab="已采购" force-render>
			<div class="content_main">
				<div class="content_main_top">
					<a-button type="primary" v-if="purchaseUpdatePurchase" :disabled="selectedRowKeysTabItems.length < 1" @click="Application">
						申请验收 </a-button>
					<!-- <a-button type="primary" @click="exp"> 数据导出 </a-button> -->
				</div>
				<div class="content_main_top">
					<a-input v-model="purchaseCodeplan" allowClear class="a_input_self margin_self" placeholder="采购申请单号"
					 @keyup.enter.native="queryplan" />
					<a-select show-search allowClear placeholder="采购申请公司" class="margin_self" @change="handlecompanyplan" v-model="companyIdplan"
					 @keyup.enter.native="queryplan" style="width: 160px">
						<a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
							{{ item.title }}
						</a-select-option>
					</a-select>
					<a-tree-select allowClear :treeData="deptTree3" v-model="deptIdplan" :disabled="!companyIdplan" placeholder="采购申请部门" class="margin_self"
					 @keyup.enter.native="queryplan" style="width: 160px" @change="handledeptplan" treeDefaultExpandAll>
					</a-tree-select>
					<!-- <a-select show-search allowClear v-model="deptIdplan" :disabled="!companyIdplan" placeholder="采购申请部门" class="margin_self"
					 @keyup.enter.native="queryplan" style="width: 160px" @change="handledeptplan">
						<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
							{{ item.dept_name }}
						</a-select-option>
					</a-select> -->
					<a-input v-model="createByplan" allowClear class="a_input_self margin_self" placeholder="采购申请人"
					 @keyup.enter.native="queryplan" />
					<a-input v-model="nameplan" allowClear class="a_input_self margin_self" placeholder="物品名称" @keyup.enter.native="queryplan" />
					<a-button type="primary" v-if='purchaseInfoPurchase' @click="queryplan"> 查询 </a-button>
					<a-button type="primary" ghost @click="resultplan"> 重置 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll">
					<a-table :columns="columnsplan" :data-source="dataplan" rowKey="goodsId" :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChange }"
					 bordered :pagination="paginationplan" @change="handleTableChangeplan" :scroll="{ x: 3150,y: scroll_y }">
						<span slot="index" slot-scope="text, record,index">
							{{ (paginationplan.current - 1) * 10 + index + 1 }}
						</span>
						<span slot="itemType" slot-scope="text">
							{{ text ?goodsTypeObj[text]:''}}
						</span>
						<span slot="paymentMethod" slot-scope="text">
							{{ text ?payMap[text]:''}}
						</span>
						<span slot="action" slot-scope="text, record">
							<a @click="editplan(record)">编辑</a>
						</span>
					</a-table>
				</div>
			</div>
			<a-modal v-model="shopvisvisible" title="采购订货-去采购" width="80%" :maskClosable="false">
				<template slot="footer">
					<a-button key="submit" type="primary" @click="moneyOk"> 确定 </a-button>
					<a-button key="back" @click="moneyCancel"> 取消 </a-button>
				</template>
				<a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
					<a-row>
						<a-col :span="8">
							<a-form-item label="采购申请单号">
								<a-input allowClear disabled v-decorator="['purchaseCode']" placeholder="请输入采购申请单号" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="资产类别">
								<a-select allowClear disabled v-decorator="['itemType', { rules: [{ required: true, message: '请选择资产类别!' }] }]"
								 placeholder="请选择">
									<a-select-option :key="index" v-for="(item, index) in goodsType" :value="item.value">
										{{ item.label }}
									</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="物品名称">
								<a-input allowClear disabled v-decorator="['name']" placeholder="请输入物品名称" />
							</a-form-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-item label="规格型号">
								<a-input allowClear disabled v-decorator="['model']" placeholder="请输入规格型号" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="申购数量">
								<a-input allowClear disabled v-decorator="['amount']" placeholder="请输入申购数量" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="单位">
								<a-input allowClear disabled v-decorator="['unit']" placeholder="请输入单位" />
							</a-form-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-item label="采购申请公司">
								<a-input allowClear disabled v-decorator="['companyName']" placeholder="请输入采购申请公司" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="采购申请部门">
								<a-tree-select disabled :treeData="deptTree" placeholder="请输入" v-decorator="['deptId', { rules: [{ required: true, message: '请选择采购申请部门!' }] }]"
								 treeDefaultExpandAll>
								</a-tree-select>
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="采购申请人">
								<a-input allowClear disabled v-decorator="['createBy']" placeholder="请输入采购申请人" />
							</a-form-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-item label="申请时间">
								<a-input allowClear disabled v-decorator="['createTime']" placeholder="请输入申请时间" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="期望交付时间">
								<a-input allowClear disabled v-decorator="['expectDate']" placeholder="请输入期望交付时间" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="备注">
								<a-input allowClear disabled v-decorator="['remark']" placeholder="请输入备注" />
							</a-form-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-item label="供应商报价均价">
								<a-input allowClear disabled v-decorator="['averageQuote']" placeholder="请输入供应商报价均价" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="采购时间">
								<a-input allowClear disabled v-decorator="['purchaseTime']" placeholder="请输入采购时间" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="供应商">
								<a-input allowClear v-decorator="['supplier', { rules: [{ required: true, message: '请输入供应商!' }] }]" placeholder="请输入供应商" />
							</a-form-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-item label="采购物品名称">
								<a-input allowClear v-if="detailsrow.goodType==1" @click="changall" v-decorator="['applyName', { rules: [{ required: true, message: '请输入采购物品名称!' }] }]"
								 placeholder="请输入采购物品名称" />
								 <a-input allowClear v-if="detailsrow.goodType==0" v-decorator="['applyName', { rules: [{ required: true, message: '请输入采购物品名称!' }] }]"
								  placeholder="请输入采购物品名称" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="采购物品规格型号">
								<a-input allowClear v-if="detailsrow.goodType==1" disabled v-decorator="['applyModel', { rules: [{ required: true, message: '请输入采购物品规格型号!' }] }]"
								 placeholder="请输入采购物品规格型号" />
								 <a-input allowClear v-if="detailsrow.goodType==0" v-decorator="['applyModel', { rules: [{ required: true, message: '请输入采购物品规格型号!' }] }]"
								  placeholder="请输入采购物品规格型号" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="采购单位">
								<a-input allowClear v-if="detailsrow.goodType==1" disabled v-decorator="['applyUnit', { rules: [{ required: true, message: '请输入采购单位!' }] }]"
								 placeholder="请输入采购单位" />
								 <a-input allowClear v-if="detailsrow.goodType==0" v-decorator="['applyUnit', { rules: [{ required: true, message: '请输入采购单位!' }] }]"
								  placeholder="请输入采购单位" />
							</a-form-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-item label="采购总金额">
								<a-input allowClear type="number" @blur="changeprice" v-decorator="['purchasePrice', { rules: [{ required: true, message: '请输入采购总金额!' }] }]"
								 placeholder="请输入采购总金额" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="采购数量">
								<a-input allowClear type="number" @blur="changeamount" v-decorator="['actualAmount', { rules: [{ required: true, message: '请输入采购数量!' }] }]"
								 placeholder="请输入采购数量" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="采购单价">
								<a-input allowClear v-decorator="['singlePrice']" placeholder="请输入采购单价" />
							</a-form-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-item label="采购人">
								<a-input allowClear disabled v-decorator="['purchaser']" placeholder="请输入采购人" />
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="支付方式">
								<a-select allowClear v-decorator="['paymentMethod', { rules: [{ required: true, message: '请选择支付方式!' }] }]"
								 placeholder="请选择支付方式">
									<a-select-option :key="index" v-for="(item, index) in payMap" :value="index">
										{{ item }}
									</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="8">
							<a-form-item label="采购备注">
								<a-input allowClear v-decorator="['applyRemark']" placeholder="请输入采购备注" />
							</a-form-item>
						</a-col>
					</a-row>
					<a-row style="margin-bottom: 15px"><span class="form_title">供应商报价</span></a-row>
					<a-row>
						<a-table :data-source="supplierList" bordered :pagination="false">
							<a-table-column key="index" title="序号" data-index="index">
								<template scope="text, record, index">{{ index + 1 }}</template>
							</a-table-column>
							<a-table-column key="supplierName" ellipsis="true" title="供应商名称" data-index="supplierName">
							</a-table-column>
							<a-table-column key="quote" ellipsis="true" title="报价（单价）" data-index="quote"></a-table-column>
							<a-table-column key="remark" ellipsis="true" title="备注" data-index="remark"></a-table-column>
						</a-table>
					</a-row>
				</a-form>
			</a-modal>
			<a-modal v-model="accepvisible" title="采购订货-验收提示" width="40%" :maskClosable="false">
				<template slot="footer">
					<a-button key="submit" type="primary" @click="accepOk"> 确定 </a-button>
					<a-button key="back" @click="accepCancel"> 取消 </a-button>
				</template>
				<a-table :data-source="selectedRow" :pagination="false" bordered :scroll="{ y: scroll_y }">
					<a-table-column key="index" title="序号" data-index="index" width="70px">
						<template scope="text, record, index">{{ index + 1 }}</template>
					</a-table-column>
					<a-table-column key="name" title="物品名称" data-index="name" />
					<a-table-column key="itemType" title="资产类别" data-index="itemType">
						<template slot-scope="text, record">
							{{ text ?goodsTypeObj[text]:''}}
						</template>
					</a-table-column>
					<a-table-column key="model" title="规格型号" data-index="model" />
					<a-table-column key="actualAmount" title="数量" data-index="actualAmount" />
					<a-table-column key="action" title="操作" data-index="action">
						<template scope="text,record">
							<a @click="deletes(record)">删除</a>
						</template>
					</a-table-column>
				</a-table>
			</a-modal>
			<a-modal v-model="editplanvisible" title="采购订货-编辑" width="50%" :maskClosable="false">
				<template slot="footer">
					<a-button key="submit" type="primary" @click="editplanOk"> 确定 </a-button>
					<a-button key="back" @click="editplanCancel"> 取消 </a-button>
				</template>
				<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol">
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="采购申请单号">
								<span>{{ detailsrow.purchaseCode }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="资产类别">
								<span>{{ detailsrow.itemType ? goodsTypeObj[detailsrow.itemType]:'' }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="物品名称">
								<span>{{ detailsrow.name }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="规格型号">
								<span>{{ detailsrow.model }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="申购数量">
								<span>{{ detailsrow.amount }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="单位">
								<span>{{ detailsrow.unit }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="采购申请公司">
								<span>{{ detailsrow.companyName }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="采购申请部门">
								<span>{{ detailsrow.deptName }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="采购申请人">
								<span>{{ detailsrow.createByName }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="申请时间">
								<span>{{ detailsrow.createTime }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="期望交付时间">
								<span>{{ detailsrow.expectDate }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="备注">
								<span>{{ detailsrow.remark }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="供应商报价均价">
								<span>{{ detailsrow.averageQuote }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="采购时间">
								<span>{{ detailsrow.purchaseTime }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="供应商">
								<a-input allowClear v-model="detailsrow.supplier" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="采购总金额">
								<a-input allowClear @blur="changeplanprice" v-model="detailsrow.purchasePrice" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="采购数量">
								<a-input allowClear @blur="changeplanamount" v-model="detailsrow.actualAmount" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="采购单价">
								<a-input allowClear v-model="detailsrow.singlePrice" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="8">
							<a-form-model-item label="采购人">
								<span>{{ detailsrow.purchaserName }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="8">
							<a-form-model-item label="支付方式">
								<a-select allowClear v-model="detailsrow.paymentMethod" placeholder="请选择支付方式">
									<a-select-option :key="index" v-for="(item, index) in payMap" :value="index">
										{{ item }}
									</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
					</a-row>
				</a-form-model>
			</a-modal>
			<a-modal v-model="detailsvisible" title="采购订货-详情" width="50%">
				<template slot="footer">
					<a-button type="primary" @click="detailsOk"> 确定 </a-button>
				</template>
				<a-form-model :model="detailsrow" :labelCol="labelCol" :wrapperCol="wrapperCol">
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="采购申请单号">
								<span>{{ detailsrow.purchaseCode }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="采购申请部门">
								<span>{{ detailsrow.deptName }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="采购申请人">
								<span>{{ detailsrow.createByName }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="资产类别">
								<span>{{ detailsrow.itemType ? goodsTypeObj[detailsrow.itemType]:'' }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="物品名称">
								<span>{{ detailsrow.name }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="规格型号">
								<span>{{ detailsrow.model }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="申购数量">
								<span>{{ detailsrow.amount }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="单位">
								<span>{{ detailsrow.unit }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="供应商报价均价">
								<span>{{ detailsrow.averageQuote }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="申请时间">
								<span>{{ detailsrow.createTime }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="期望交付时间">
								<span>{{ detailsrow.expectDate }}</span>
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="备注">
								<span>{{ detailsrow.remark }}</span>
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row style="margin-bottom: 15px"><span class="form_title">供应商报价</span></a-row>
					<a-row>
						<a-table :data-source="supplierList" bordered :pagination="false">
							<a-table-column key="index" title="序号" data-index="index">
								<template scope="text, record, index">{{ index + 1 }}</template>
							</a-table-column>
							<a-table-column key="supplierName" ellipsis="true" title="供应商名称" data-index="supplierName">
							</a-table-column>
							<a-table-column key="quote" ellipsis="true" title="报价（单价）" data-index="quote"></a-table-column>
							<a-table-column key="remark" ellipsis="true" title="备注" data-index="remark"></a-table-column>
						</a-table>
					</a-row>
				</a-form-model>
			</a-modal>
			<a-modal title="请选择物品" v-model="changevisible" width="1200px">
				<template slot="footer">
					<a-button key="back" @click="changevisible=false"> 取消 </a-button>
					<a-button key="submit" type="primary" @click="surechange"> 确定 </a-button>
				</template>
				<a-table :data-source="changedata" bordered rowKey="id" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange2, type: 'radio' }"
				 :pagination="pagination2" @change="handleTableChange2">
					<a-table-column key="index" title="序号" data-index="index" width="70px">
						<template scope="text, record, index">{{ (pagination2.current-1)*10+index+1 }}</template>
					</a-table-column>
					<a-table-column key="companyName" title="公司名称" data-index="companyName" />
					<a-table-column key="spuSn" title="物品编码" data-index="spuSn" />
					<a-table-column key="name" title="物品名称" data-index="name" />
					<a-table-column key="model" title="规格型号" data-index="model" />
					<a-table-column key="unit" title="单位" data-index="unit" />
				</a-table>
			</a-modal>
		</a-tab-pane>
	</a-tabs>
</template>
<script>
	import {
		purchase_apply_quote
	} from '@/api/activiti'
	import {
		dict,
		getPurchaseList
	} from '@/api/assetmenag'
	import {
		selectBizPurchaseList,
		updateBizGoodsInfo,
		updateBizGoodsInfoList,
		updateBizGoodsInfoListPlan,
		purchase_apply_listAaSpuByName,
		purchase_apply_AaSpuById,
		purchase_list_delete,
		tree_all
	} from '@/api/purchase'
	import {
		getDeptListEnable2
	} from '@/api/system'
	import {
		checkPermission
	} from '@/utils/permissions'
	const deptMap = {}
	const operTypeMap = {}
	const columns = [{
			title: '序号',
			dataIndex: 'index',
			key: 'index',
			scopedSlots: {
				customRender: 'index',
			},
			width: 70,
			ellipsis: true,
		}, {
			title: '采购申请单号',
			dataIndex: 'purchaseCode',
			key: 'purchaseCode',
			width: 250,
			ellipsis: true,
		},
		{
			title: '采购申请公司',
			dataIndex: 'companyName',
			key: 'companyName',
			ellipsis: true,
		},
		{
			title: '采购申请部门',
			dataIndex: 'deptName',
			key: 'deptName',
			ellipsis: true,
		},
		{
			title: '采购申请人',
			dataIndex: 'createByName',
			key: 'createByName',
			ellipsis: true,
		},
		{
			title: '资产类别',
			dataIndex: 'itemType',
			key: 'itemType',
			scopedSlots: {
				customRender: 'itemType',
			},
			ellipsis: true,
		},
		{
			title: '物品名称',
			dataIndex: 'name',
			key: 'name',
			ellipsis: true,
		},
		{
			title: '规格型号',
			dataIndex: 'model',
			key: 'model',
			ellipsis: true,
		},
		{
			title: '申购数量',
			dataIndex: 'amount',
			key: 'amount',
			ellipsis: true,
		},
		{
			title: '单位',
			dataIndex: 'unit',
			key: 'unit',
			width: 70,
			ellipsis: true,
		},
		{
			title: '供应商报价均价',
			dataIndex: 'averageQuote',
			key: 'averageQuote',
			ellipsis: true,
		},
		{
			title: '申请时间',
			dataIndex: 'createTime',
			key: 'createTime',
			ellipsis: true,
		},
		{
			title: '期望交付时间',
			dataIndex: 'expectDate',
			key: 'expectDate',
			ellipsis: true,
		},
		{
			title: '备注',
			dataIndex: 'remark',
			key: 'remark',
			ellipsis: true,
		},
		{
			title: '操作',
			key: 'action',
			scopedSlots: {
				customRender: 'action',
			},
			fixed: 'right',
			width: 200,
		},
	]
	const columnsplan = [{
			title: '序号',
			dataIndex: 'index',
			key: 'index',
			scopedSlots: {
				customRender: 'index',
			},
			ellipsis: true,
		}, {
			title: '采购申请单号',
			dataIndex: 'purchaseCode',
			key: 'purchaseCode',
			ellipsis: true,
		},
		{
			title: '采购申请公司',
			dataIndex: 'companyName',
			key: 'companyName',
			ellipsis: true,
		},
		{
			title: '采购申请部门',
			dataIndex: 'deptName',
			key: 'deptName',
			ellipsis: true,
		},
		{
			title: '采购申请人',
			dataIndex: 'createByName',
			key: 'createByName',
			ellipsis: true,
		},
		{
			title: '资产类别',
			dataIndex: 'itemType',
			key: 'itemType',
			scopedSlots: {
				customRender: 'itemType',
			},
			ellipsis: true,
		},
		{
			title: '物品名称',
			dataIndex: 'name',
			key: 'name',
			ellipsis: true,
		},
		{
			title: '规格型号',
			dataIndex: 'model',
			key: 'model',
			ellipsis: true,
		},
		{
			title: '申购数量',
			dataIndex: 'amount',
			key: 'amount',
			ellipsis: true,
		},
		{
			title: '单位',
			dataIndex: 'unit',
			key: 'unit',
			ellipsis: true,
		},
		{
			title: '采购物品名称',
			dataIndex: 'applyName',
			key: 'applyName',
			ellipsis: true,
		},
		{
			title: '采购规格型号',
			dataIndex: 'applyModel',
			key: 'applyModel',
			ellipsis: true,
		},
		{
			title: '采购数量',
			dataIndex: 'actualAmount',
			key: 'actualAmount',
			ellipsis: true,
		},
		{
			title: '采购单位',
			dataIndex: 'applyUnit',
			key: 'applyUnit',
			ellipsis: true,
		},
		{
			title: '采购备注',
			dataIndex: 'applyRemark',
			key: 'applyRemark',
			ellipsis: true,
		},
		{
			title: '申请时间',
			dataIndex: 'createTime',
			key: 'createTime',
			ellipsis: true,
		},
		{
			title: '期望交付时间',
			dataIndex: 'expectDate',
			key: 'expectDate',
			ellipsis: true,
		},
		{
			title: '备注',
			dataIndex: 'remark',
			key: 'remark',
			ellipsis: true,
		},
		{
			title: '采购总金额',
			dataIndex: 'purchasePrice',
			key: 'purchasePrice',
			ellipsis: true,
		},
		{
			title: '采购单价',
			dataIndex: 'singlePrice',
			key: 'singlePrice',
			ellipsis: true,
		},
		{
			title: '供应商',
			dataIndex: 'supplier',
			key: 'supplier',
			ellipsis: true,
		},
		{
			title: '采购人',
			dataIndex: 'purchaserName',
			key: 'purchaserName',
			ellipsis: true,
		},
		{
			title: '采购时间',
			dataIndex: 'purchaseTime',
			key: 'purchaseTime',
			ellipsis: true,
		},
		{
			title: '支付方式',
			dataIndex: 'paymentMethod',
			key: 'paymentMethod',
			scopedSlots: {
				customRender: 'paymentMethod',
			},
			ellipsis: true,
		},
		{
			title: '操作',
			key: 'action',
			scopedSlots: {
				customRender: 'action',
			},
			fixed: 'right',
			width: 150,
		},
	]
	export default {
		data() {
			return {
				supplierList:[],
				deptMap,
				name:'',
				operTypeMap,
				columns,
				columnsplan,
				deptTree: [],
				deptTree2: [],
				deptTree3: [],
				selectedRowKeysTab: [],
				selectedRowKeys: [],
				selectedRowKeysTabItems: [],
				detailsrow: '',
				data: '',
				changedata:[],
				dataplan: '',
				shopvisvisible: false,
				editplanvisible: false,
				scroll_y: 150,
				itemType: undefined,
				createBy: undefined,
				purchaseCode: undefined,
				companyId: undefined,
				deptId: undefined,
				createByplan: undefined,
				purchaseCodeplan: undefined,
				companyIdplan: undefined,
				deptIdplan: undefined,
				nameplan: undefined,
				accepvisible: false,
				detailsvisible: false,
				changevisible:false,
				companylist: [],
				deptlist: [],
				form: this.$form.createForm(this),
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				paginationplan: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				pagination2: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				labelCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 8,
					},
				},
				wrapperCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 16,
					},
				},
				spuIdList:{},
				purchaseInfoPurchase: checkPermission('purchase:list:info'),
				purchaseUpdatePurchase: checkPermission('purchase:list:update'),
			};
		},
		created() {
			tree_all().then((res) => {
				this.companylist = res.data[0]
				this.companylist.unshift({
					deptId: 0,
					title: '所有公司',
					children: [],
				})
			})
			getDeptListEnable2().then((res) => {
				const data = res.rows
				if (data.length > 0) {
					const min = Math.min(...data.map((m) => m.parentId))
					this.buildtree2(data, this.deptTree, min)
					this.deptTree.map((d) => {
						if (d.hasOwnProperty('children')) {
							d.children.map((b) => {
								deptMap[b.key] = {
									text: b.title,
								}
								deptMap[d.key] = {
									text: d.title,
								}
							})
						} else {
							deptMap[d.key] = {
								text: d.title,
							}
						}
					})
					this.expandedKeys = data.map((m) => m.parentId)
					this.dataList = data.map((m) => {
						return {
							key: m.deptId,
							title: m.deptName,
						}
					})
				}
			})
			dict({
				pageNum: 1,
				pageSize: 10,
				dictType: 'assets_type',
			}).then((res) => {
				this.assettype = res.rows
				this.assettype.map((d) => {
					this.operTypeMap[d.dictCode] = {
						text: d.dictLabel,
					}
				})
			})
			this.get_sel()
			this.get_selplan()
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 120
				}, 1000)
			})
		},
		methods: {
			//导出
 		exportData() {
			getPurchaseList({  
				status: 0,
				itemType: this.itemType,
				purchaseCode: this.purchaseCode,
				ancestors: this.companyId,
				deptId: this.deptId,
				createBy: this.createBy,
				name:this.name})
		},
			voids(row){
				var _this = this
				this.$confirm({
					title: '确认作废此物品吗?',
					onOk() {
						purchase_list_delete(row.goodsId).then(res=>{
							if (res.code == 200) {
								_this.$message.success('作废成功！')
							} else {
							_this.$message.error(res.msg)
								return
							}
							_this.get_sel()
						})
					},
					onCancel() {
						_this.$message.error('你点击了取消！')
					},
					class: 'test',
				})
			},
			surechange() {
				this.changevisible = false
				var _this = this
				this.selectedRowKeys.forEach(item => {
					purchase_apply_AaSpuById({
						id: item
					}).then(res => {
						this.spuIdList=res.data
						this.form.setFieldsValue({
							applyName:res.data.name,
							applyModel:res.data.model,
							applyUnit:res.data.unit,
						})
					})
				})
			},
			onSelectChange2(selectedRowKeys) {
				console.log(selectedRowKeys)
				this.selectedRowKeys = selectedRowKeys
			},
			changall() {
				this.changevisible = true
				this.sku_get()
			},
			changeplanprice() {
				if (this.detailsrow.actualAmount) {
					this.detailsrow.singlePrice = Number(this.detailsrow.purchasePrice / this.detailsrow.actualAmount).toFixed(2)
				}
				if(this.detailsrow.actualAmount==0){
					this.detailsrow.singlePrice=0.00
				}
			},
			changeplanamount() {
				if (this.detailsrow.purchasePrice) {
					this.detailsrow.singlePrice = Number(this.detailsrow.purchasePrice / this.detailsrow.actualAmount).toFixed(2)
				}
				if(this.detailsrow.actualAmount==0){
					this.detailsrow.singlePrice=0.00
				}
			},
			editplanCancel() {
				this.editplanvisible = false
			},
			editplanOk() {
				updateBizGoodsInfoListPlan({
					id: this.detailsrow.goodsId,
					supplier: this.detailsrow.supplier,
					purchasePrice: this.detailsrow.purchasePrice,
					actualAmount: this.detailsrow.actualAmount,
					singlePrice: this.detailsrow.singlePrice,
					paymentMethod: this.detailsrow.paymentMethod,
				}).then((res) => {
						if (res.code === 200) {
							this.$message.success('编辑成功')
							this.$emit('ok')
							this.editplanvisible = false
							this.get_selplan()
						} else {
							this.$message.success(res.msg)
						}
					})
					.catch(() => {
						this.$message.error('系统错误，请稍后再试')
					})
			},
			callback(key) {
				if (key == 1) {
					this.get_sel()
				} else if (key == 2) {
					this.get_selplan()
				}
			},
			deletes(row) {
				var index = this.selectedRowKeysTab.indexOf(row.goodsId)
				this.selectedRowKeysTab.splice(index, 1)
				this.selectedRowKeysTabItems.splice(index, 1)
			},
			onSelectChange(selectedRowKeys, selectedRows) {
				var arr = JSON.parse(JSON.stringify(selectedRows))
				this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.concat(arr)
				this.selectedRowKeysTab = selectedRowKeys
				var obj = {}
				this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.reduce(function(item, next) {
					obj[next.goodsId] ? '' : (obj[next.goodsId] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeysTab.forEach((key, idx) => {
					this.selectedRowKeysTabItems.forEach((item, index) => {
						if (key == item.goodsId) {
							newLis.push(item)
						}
					})
				})
				this.selectedRowKeysTabItems = newLis
			},
			accepCancel() {
				this.accepvisible = false
			},
			accepOk() {
				var list = []
				this.selectedRowKeysTabItems.forEach(item => {
					list.push({
						id: item.goodsId,
						isReceived: 1
					})
				})
				updateBizGoodsInfoList(list).then((res) => {
						if (res.code === 200) {
							this.$message.success('申请验收成功')
							this.$emit('ok')
							this.accepvisible = false
							this.get_selplan()
							this.selectedRowKeysTabItems = []
						} else {
							this.$message.success(res.msg)
						}
					})
					.catch(() => {
						this.$message.error('系统错误，请稍后再试')
					})

			},
			editplan(row) {
				var rows = row
				let resData = {}
				for (let key in rows) {
					resData[key] = rows[key]
				}
				this.detailsrow = resData
				this.editplanvisible = true
			},
			handledept(value) {
				this.deptId = value
			},
			handledeptplan(value) {
				this.deptIdplan = value
			},
			handlecompany(value) {
				this.deptTree2 = []
				this.deptlist = []
				this.deptId = undefined
				this.$nextTick(() => {
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree2, this.companyId)
						}
					})
				})
			},
			handlecompanyplan(value) {
				this.deptTree3=[]
				this.deptlist = []
				this.deptIdplan = undefined
				this.$nextTick(() => {
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree3, this.companyIdplan)
						}
					})
				})
			},
			changeamount() {
				if (this.form.getFieldValue('purchasePrice') && this.form.getFieldValue('actualAmount')) {
					var price = Number(this.form.getFieldValue('purchasePrice') / this.form.getFieldValue('actualAmount')).toFixed(2)
					this.form.setFieldsValue({
						singlePrice: price,
					})
				}
				if(this.form.getFieldValue('actualAmount')==0){
					this.form.setFieldsValue({
						singlePrice: 0.00,
					})
				}
			},
			changeprice() {
				if (this.form.getFieldValue('actualAmount') && this.form.getFieldValue('purchasePrice')) {
					var price = Number(this.form.getFieldValue('purchasePrice') / this.form.getFieldValue('actualAmount')).toFixed(2)
					this.form.setFieldsValue({
						singlePrice: price,
					})
				}
				if(this.form.getFieldValue('actualAmount')==0){
					this.form.setFieldsValue({
						singlePrice: 0.00,
					})
				}
			},
			detailsOk() {
				this.detailsvisible = false
			},
			details(row) {
				this.detailsrow = row
				this.detailsvisible = true
				this.getsupplierList(row)
			},
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			get_sel() {
				selectBizPurchaseList({
					status: 0,
					pageSize: this.pagination.pageSize,
					pageNum: this.pagination.current,
					itemType: this.itemType,
					purchaseCode: this.purchaseCode,
					ancestors: this.companyId,
					deptId: this.deptId,
					createBy: this.createBy,
					name:this.name
				}).then(res => {
					const pagination = { ...this.pagination
					}
					pagination.total = res.total
					this.pagination = pagination
					this.data = res.rows
				})
			},
			sku_get() {
				purchase_apply_listAaSpuByName({
					page_size: this.pagination2.pageSize,
					page_num: this.pagination2.current,
					deptId:this.detailsrow.deptId,
					name:this.detailsrow.name,
				}).then((res) => {
					const pagination = { ...this.pagination2
					}
					pagination.total = res.total
					this.pagination2 = pagination
					this.changedata = res.rows
				})
			},
			get_selplan() {
				selectBizPurchaseList({
					status: 1,
					pageSize: this.paginationplan.pageSize,
					pageNum: this.paginationplan.current,
					createBy: this.createByplan,
					purchaseCode: this.purchaseCodeplan,
					ancestors: this.companyIdplan,
					deptId: this.deptIdplan,
					name: this.nameplan,
				}).then(res => {
					const paginationplan = { ...this.paginationplan
					}
					paginationplan.total = res.total
					this.paginationplan = paginationplan
					this.dataplan = res.rows
				})
			},
			Application(row) {
				this.selectedRow = this.selectedRowKeysTabItems
				this.accepvisible = true
			},
			Goshopping(row) {
				this.form.resetFields()
				this.detailsrow = row
				this.shopvisvisible = true
				var date = new Date();
				console.log(date)
				var getMonth = date.getMonth() + 1
				var update_time = date.getFullYear() + '-' + getMonth + '-' + date.getDate() + ' ' + date.getHours() + ':' +
					date.getMinutes() + ':' + date.getSeconds()
				console.log(date.getMonth())
				this.$nextTick(() => {
					this.form.setFieldsValue({
						purchaser: this.$store.getters.userInfo.userName,
						purchaseTime: update_time,
						applyName:this.detailsrow.applyName,
						applyModel:this.detailsrow.applyModel,
						applyUnit:this.detailsrow.applyUnit,
						purchaseCode: this.detailsrow.purchaseCode,
						itemType: this.detailsrow.itemType,
						name: this.detailsrow.name,
						companyName: this.detailsrow.companyName,
						deptId: this.detailsrow.deptId,
						createBy: this.detailsrow.createByName,
						amount: this.detailsrow.amount,
						unit: this.detailsrow.unit,
						model: this.detailsrow.model,
						createTime: this.detailsrow.createTime,
						expectDate: this.detailsrow.expectDate,
						remark: this.detailsrow.remark,
						averageQuote: this.detailsrow.averageQuote,
					})
				})
				this.getsupplierList(row)
			},
			getsupplierList(row){
				purchase_apply_quote(row.goodsId).then(res => {
					this.supplierList = res.data.list
				})
			},
			moneyOk() {
				this.form.validateFields((err, values) => {
					if (!err) {
						values['id'] = this.detailsrow.goodsId
						values['spuId']= this.spuIdList.id
						values['isPurchase'] = 1
						values['createBy'] = this.detailsrow.createBy
						values['purchaser'] = this.$store.getters.userInfo.loginName
						var value = values
						let resData = {}
						for (let key in value) {
							resData[key] = value[key]
						}
						updateBizGoodsInfo(resData).then((res) => {
								if (res.code === 200) {
									this.$message.success('采购成功')
									this.$emit('ok')
									this.shopvisvisible = false
									this.get_sel()
									this.spuIdList={}
								} else {
									this.$message.error(res.msg)
								}
							})
							.catch(() => {
								this.$message.error('系统错误，请稍后再试')
							})
					}
				})
			},
			moneyCancel() {
				this.shopvisvisible = false
			},
			//搜索
			query() {
				this.pagination.current = 1
				this.get_sel()
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.pagination.pageSize = pagination.pageSize
				this.get_sel()
			},
			handleTableChange2(pagination, filters, sorter) {
				this.pagination2.current = pagination.current
				this.pagination2.pageSize = pagination.pageSize
				this.sku_get()
			},
			handleTableChangeplan(pagination, filters, sorter) {
				this.paginationplan.current = pagination.current
				this.paginationplan.pageSize = pagination.pageSize
				this.get_selplan()
			},
			result() {
				this.itemType = undefined
				this.purchaseCode = undefined
				this.companyId = undefined
				this.deptId = undefined
				this.createBy = undefined
				this.name=''
			},
			queryplan() {
				this.paginationplan.current = 1
				this.get_selplan()
			},
			resultplan() {
				this.createByplan = undefined
				this.purchaseCodeplan = undefined
				this.companyIdplan = undefined
				this.deptIdplan = undefined
				this.nameplan = undefined
			},
		},
	};
</script>

<style scoped lang='less'>
	.form_title {
		margin-left: 15px;
		margin-bottom: 15px;
		font-size: 17px;
		color: #999;
	}
</style>
